/**
 * @file Settles a charge with another or a new charge through `charge/:id/settle` and confirms it in a snackbar.
 * A refusal the charge-settle route is known to send opens the refusal dialog with that path's texts.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";
import Translator from "../../Translation/Translator";

const EXPECTED_ERRORS: ExpectedErrors = {
  be_ajv_not_validated: null,
  financial_operations_were_blocked: { titleKey: "refusal-title-settle", bodyKey: "refusal-body-financial-processing-busy" },
  cannot_settle_direct_charge: { titleKey: "refusal-title-settle", bodyKey: "refusal-body-settle-direct-charge" },
  cannot_settle_charges_with_equal_types: { titleKey: "refusal-title-settle", bodyKey: "refusal-body-settle-equal-charge-types" },
  forbidden_to_settle_payout: { titleKey: "refusal-title-settle", bodyKey: "refusal-body-settle-payout" }
};

export default function* chargeSettle(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_SETTLE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_SETTLE_REQUEST
    });

    let payload: any = {};

    if (!!action.payload?.existedChargeId) {
      payload.existedChargeId =  action.payload?.existedChargeId;
    }

    if (!!action.payload?.newCharge) {
      payload.newCharge = {...action.payload?.newCharge};
    }

    const res = yield call(Http.post, `charge/${action.payload?.id}/settle`, {
      ...payload
    });

    const charge: ChargeInterface = ChargeFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_CHARGE_SETTLE_SUCCESS
    })

    yield put({
      type: Constants.GLOBAL_CHARGE_UPDATE_SUCCESS,
      payload: {
        charge
      }
    })

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-settled-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, charge);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

    yield put({
      type: Constants.GLOBAL_CHARGE_SETTLE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeSettle() {
  yield takeEvery(Constants.GLOBAL_CHARGE_SETTLE_START, chargeSettle);
}
